export var lr = window['lr'];
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../~/xm-ui/leadsraiser/index.js
// module id = 11
// module chunks = 1